import React, {Component} from 'react';

import {Table as BootstrapTable, Button} from 'react-bootstrap'
import CRUDForm from './_form';
import ViewForm from './_view';

class Form extends Component {
	render() {
		let {formType} = this.props;

		switch (formType.toUpperCase()) {
			case '':
				return ''
			case 'VIEW':
				return <ViewForm {...this.props}/>
			default:
				return <CRUDForm {...this.props}/>
		}
	}
	componentDidMount() {
		let {
			selectedDataPointer,
			selectedDataBoolean,
			selectedParseFile,
			selectedData,
			stateSetter,
			schema
		} = this.props;

		const isUndefined = (obj) => typeof obj === 'undefined'
			? true
			: false

		schema.columns.map(({
			columnName,
			columnLabel,
			type,
			format,
			targetClass,
			displayColumn
		}) => {
			switch (type.toUpperCase()) {
				case 'POINTER':
					selectedDataPointer[columnName] = (isUndefined(selectedData.get(columnName))
						? null
						: {
							label: selectedData.get(columnName).get(displayColumn),
							value: selectedData.get(columnName).id
						});

					if (!isUndefined(selectedData.get(columnName))) {
						stateSetter([
							{
								state: 'selectedDataPointer',
								value: selectedDataPointer
							}
						]);
					}
					break;
				case 'BOOLEAN':
					selectedDataBoolean[columnName] = (isUndefined(selectedData.get(columnName))
						? null
						: {
							label: selectedData.get(columnName).toString().toUpperCase(),
							value: selectedData.get(columnName).toString()
						});

					if (!isUndefined(selectedData.get(columnName))) {
						stateSetter([
							{
								state: 'selectedDataBoolean',
								value: selectedDataBoolean
							}
						]);
					}
				case 'PARSEFILE':
					selectedParseFile[columnName] = (isUndefined(selectedData.get(columnName))
						? undefined
						: selectedData.get(columnName));

					if (!isUndefined(selectedData.get(columnName))) {
						stateSetter([
							{
								state: 'selectedParseFile',
								value: selectedParseFile
							}
						]);
					}
					break;
				default:

			}
		});
	}
}
// const Form = props => {
// 	let {formType} = props
// 	const getForm = (type) => {
// 		switch (type.toUpperCase()) {
// 			case '':
// 				return ''
// 			case 'VIEW':
// 				return <ViewForm {...props}/>
// 			default:
// 				return <CRUDForm {...props}/>
// 		}
// 	}
//
// 	return getForm(formType)
// }
export default Form;



// WEBPACK FOOTER //
// ./components/zynappse-crud/Form/index.js